import React from "react";

import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Typography,
} from "@material-ui/core";

import ChevronDown from "../../../autorizaciones/UI/ChevronDown";
import { PresupuestoItem } from "./PresupuestosItem";

export const MesaEntradaAccordionPresupuestos = (props) => {
  const { presupuestos, expanded, setExpanded } = props;

  return (
    <Accordion expanded={expanded} TransitionProps={{ unmountOnExit: true }} onChange={() => {setExpanded(!expanded)}}>
      <AccordionSummary expandIcon={<ChevronDown />}>
        <Typography variant="h6">Presupuestos Autorizados</Typography>
      </AccordionSummary>
      <AccordionDetails>
        {presupuestos?.length > 0 ? (
          <Table>
            <TableHead>
              <TableRow>
                <TableCell align="center" style={{ width: "7%" }}>Estado</TableCell>
                <TableCell align="center" style={{ width: "10%" }}>Presupuesto</TableCell>
                <TableCell align="center" style={{ width: "15%" }}>N° Afiliado</TableCell>
                <TableCell align="center" style={{ width: "15%" }}>Nombre Afiliado</TableCell>
                <TableCell align="center" style={{ width: "15%" }}>Fecha Carga</TableCell>
                <TableCell align="center" style={{ width: "15%" }}>Tipo Presupuesto</TableCell>
                <TableCell align="center" style={{ width: "15%" }}>Con Internación</TableCell>
                <TableCell align="center" style={{ width: "15%" }}>Diagnóstico</TableCell>
                <TableCell align="center" style={{ width: "20%" }}></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {presupuestos.map((presupuesto, index) => {
                return (
                  <PresupuestoItem
                    key={index}
                    presupuesto={presupuesto}
                  />
                );
              })}
            </TableBody>
          </Table>
        ) : (
          <Typography style={{ fontSize: "1.1rem", fontStyle: "italic" }}>
            No hay Presupuestos
          </Typography>
        )}
      </AccordionDetails>
    </Accordion>
  );
};
